import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'
import { useGetLicensingInfoOnMount } from '@user/store/licensing/hooks/useGetLicensingInfoOnMount'
import { useSelector } from 'react-redux'
import { selectLicenseInformation } from '@user/store/licensing/slice'

export default function LicenseInformation() {
  useGetLicensingInfoOnMount()

  const licenseInformation = useSelector(selectLicenseInformation)
  return (
    <Stack direction="row" alignItems={'center'} gap={3} mb={1}>
      <Typography fontWeight={600} variant="body2">
        Licenses:
      </Typography>
      <Stack direction="row" alignItems={'center'} gap={2}>
        <Typography variant="body2">Available</Typography>
        <Typography fontWeight={600} variant="body2">
          {licenseInformation?.availableLicenses}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems={'center'} gap={2}>
        <Typography variant="body2">Used</Typography>
        <Typography fontWeight={600} variant="body2">
          {licenseInformation
            ? Number(licenseInformation?.totalLicenses) -
              Number(licenseInformation?.availableLicenses)
            : ''}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems={'center'} gap={2}>
        <Typography variant="body2">Total</Typography>
        <Typography fontWeight={600} variant="body2">
          {licenseInformation?.totalLicenses}
        </Typography>
      </Stack>
    </Stack>
  )
}
